import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {Resume} from '../models/Resume';
import {DxDataGridComponent} from 'devextreme-angular';
import {MatDialog} from '@angular/material/dialog';
import {ConfirmDialogComponent} from '../../../shared/confirm-dialog/confirm-dialog.component';
import {ToastMessagesService} from '../../../../services/toast-messages.service';
import {ResumeService} from '../../../../services/resume.service';
import {Router} from '@angular/router';
import {environment} from '../../../../../environments/environment';

@Component({
  selector: 'app-resumes-table',
  templateUrl: './resumes-table.component.html',
  styleUrls: ['./resumes-table.component.scss']
})
export class ResumesTableComponent implements OnInit {

  constructor(public dialog: MatDialog,
              public router: Router,
              private resumesService: ResumeService,
              public toastService: ToastMessagesService) {
    this.showFilterRow = true;
    this.isLoading = false;
    this.showHeaderFilter = true;
    this.applyFilterTypes = [{
      key: 'auto',
      name: 'Immediately',
    }, {
      key: 'onClick',
      name: 'On Button Click',
    }];

    this.currentFilter = this.applyFilterTypes[0].key;
    this.orderHeaderFilter = this.orderHeaderFilter.bind(this);
    this.viewName = '';
    this.isViewSaving = false;
    this.isViewSubmitting = false;
    this.views = {
      isDisplaying: false,
      isLoading: true,
      isDeleting: false,
      isUpdating: false,
      records: []
    };
  }

  private static tableState: any;
  viewName: string;
  isViewSaving: boolean;
  resumes: Resume[] = [];
  @Input() isReport: boolean;
  @ViewChild(DxDataGridComponent, {static: true})
  dataGrid!: DxDataGridComponent;
  model = 'resume-table';
  currentFilter: any;
  showFilterRow: boolean;
  showHeaderFilter: boolean;
  applyFilterTypes: any;
  isLoading: boolean;
  isViewSubmitting: boolean;
  views: any;

  private static getOrderDay(rowData: { OrderDate: string | number | Date; }) {
    return (new Date(rowData.OrderDate)).getDay();
  }

//#endregion
  async fetchResumes(): Promise<Resume[]> {
    try {
      return await this.resumesService.fetchResumes();
    } catch (e) {
      this.toastService.toastErrorMessage(e.message);
    }
  }

  async ngOnInit(): Promise<void> {
    await this.initializeComponent();
  }

  async initializeComponent(): Promise<void> {
    this.resumes = await this.fetchResumes();
  }

  hideViews() {
    this.views.isDisplaying = false;
  }

  calculateColumnFilterExpression(value: string, selectedFilterOperations: any, target: string) {
    const column = this as any;
    console.log(value);
    console.log(selectedFilterOperations);
    console.log(target);
    // if (target === 'headerFilter' && value === 'weekends') {
    //   return [[ResumesTableComponent.getOrderDay, '=', 0], 'or', [ResumesTableComponent.getOrderDay, '=', 6]];
    // }
    // return column.defaultCalculateFilterExpression.apply(this, arguments);
  }

  calculateFilterExpression(value: string, selectedFilterOperations: any, target: string) {
    const column = this as any;
    if (target === 'headerFilter' && value === 'weekends') {
      return [[ResumesTableComponent.getOrderDay, '=', 0], 'or', [ResumesTableComponent.getOrderDay, '=', 6]];
    }
    return column.defaultCalculateFilterExpression.apply(this, arguments);
  }

  orderHeaderFilter(data: { dataSource: { postProcess: (results: any) => any; }; }) {
    data.dataSource.postProcess = (results) => {
      results.push({
        text: 'Weekends',
        value: 'weekends',
      });
      return results;
    };
  }


  onExporting(e: any) {
    console.log(e);
  }

  //#region State Management
  saveState(state) {
    ResumesTableComponent.tableState = state;
  }


  loadState() {}

  //#endregion

  handleOptionChanged($event: any) {
    const actionName = $event.name;
    switch (actionName) {
      case 'columns':
        const event = $event.fullName;
        const splitEvent = event.split('.');
        const name = splitEvent[1];
        if (name === 'groupIndex') {
          console.log('group');
        }

        if (name === 'sortOrder') {
          console.log('sorting');
        }

        if (name === 'visibleIndex') {
          console.log('reOrder');
        }
        break;
      case 'dataSource':
        break;
    }
    console.log($event);
  }

  //#region Action Buttons
  async editForm(column: any) {
    await this.router.navigate(['/home/resume-creator'], {queryParams: {mode: 'edit', id: column.data.id}});
  }

  async previewForm(column: any) {
    await this.router.navigate(['/home/resume-creator'], {queryParams: {mode: 'preview', id: column.data.id}});
  }

  async navigateToResumeDetails(column: any) {
    await this.router.navigate(['/home/resume-report-details'], {
      queryParams: {
        id: column.data.id,
        uniqueId: column.data.uniqueId
      }
    });
  }

  async copy(column: any) {
      try {
        this.isLoading = true;
        const id = column.data.id;
        await this.resumesService.duplicateResume(id);
        this.toastService.toastMessages('Η φόρμα δημιουργήθηκε με επιτυχία');
        await this.initializeComponent();
      } catch (e) {
        this.toastService.toastErrorMessage(e.message);
      } finally {
        this.isLoading = false;
      }
  }

  copyLink(column: any) {
    const baseUrl = environment.baseUrl;
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = `${baseUrl}/#/resume-form?edit=true&uniqueId=${column.data.uniqueId}`;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.toastService.toastMessages(`Ο σύνδεσμος αντιγράφηκε στο πρόχειρό σας`);
  }

  deleteForm(column: any) {
    const confirm = this.dialog.open(ConfirmDialogComponent, {
      data: {
        message: 'Είστε σίγουροι ότι Θέλετε να διαγράψετε τη φόρμα?',
        title: 'Διαγραφή φόρμας',
        icon: 'delete',
        iconColor: 'blue',
      }
    });

    confirm.afterClosed().subscribe(async response => {
      try {
        this.isLoading = true;
        await this.resumesService.deleteForm(column.data.id);
        this.toastService.toastMessages('Η φόρμα διαγράφηκε με επιτυχία');
        await this.initializeComponent();
      } catch (e) {
        this.toastService.toastErrorMessage(e.message);
      } finally {
        this.isLoading = false;
      }
    });
  }

  //#endregion

  async loadViews() {
    this.views.isDisplaying = true;
    this.views.isLoading = true;

    try {
      const request = await this.resumesService.fetchUserTableViews(this.model);
      request.object.map(r => r.state = JSON.parse(r.state));
      this.views.records = request.object;
    } catch (e) {
      this.toastService.toastErrorMessage('Δεν μπορέσαμε να φορτώσουμε τις απεικονίσης σας');
    } finally {
      this.views.isLoading = false;
    }
  }

  initViewStoring() {
    this.isViewSaving = true;
  }


  async submitView() {
    try {
      this.isViewSubmitting = true;
      const view = {
        name: this.viewName,
        state: JSON.stringify(ResumesTableComponent.tableState),
        model: this.model
      };
      await this.resumesService.storeUserTableView(view);
      this.toastService.toastMessages('Η απεικόνιση του πίνακα αποθηκεύτηκε με επιτυχία');
      await this.loadViews();
    } catch (e) {
      this.toastService.toastErrorMessage(e.message);
    } finally {
      this.isViewSubmitting = false;
    }
  }

  closeViewSaving() {
    this.viewName = '';
    this.isViewSaving = false;
  }

  deleteView(id: number): void {
    const confirm = this.dialog.open(ConfirmDialogComponent, {
      data: {
        message: 'Είστε σίγουροι ότι Θέλετε να διαγράψετε το πρότυπο εμφάνισης?',
        title: 'Διαγραφή προτύπου',
        icon: 'delete',
        iconColor: 'blue',
      }
    });

    confirm.afterClosed().subscribe(async response => {
      if (response) {
        try {
          this.views.isDeleting = true;
          await this.resumesService.deleteUserTableView(id);
          this.toastService.toastMessages('Το πρότυπο διαγράφηκε με επιτυχία');
          await this.loadViews();
        } catch (e) {
          this.toastService.toastErrorMessage(e.message);
        } finally {
          this.views.isDeleting = false;
        }
      }
    });
  }

  shouldBeDisabled() {
    return this.views.isLoading || this.views.isDeleting || this.views.isUpdating || this.isViewSubmitting;
  }

  applyView(state: any) {
    console.log(state);

    this.dataGrid.instance.state(state);
  }
}
